<template></template>

<script>
export default {
  data() {
    return {
      ad_imps: [],
      xtoken: ""
    }
  },
  methods: {
    async ad_imp(ad_id, url) {
      let vm = this;
      if (!vm.ad_imps.includes(ad_id)) {
        vm.ad_imps.push(ad_id);
        axios.post('/api/send/ad/imp', { url: url }, {
          headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
        })
          .then(function (response) {
            return true;
          })
          .catch(function (error) {
            return false;
          });
      }
    },
    async scrollListener() {
      let vm = this;
      document.addEventListener('scroll', function () {
        var ads = document.getElementsByClassName('sponsored_ad');
        for (var i = 0, len = ads.length; i < len; i++) {
          if (vm.isInViewport(ads[i])) {
            let ad_imp_url = ads[i].getAttribute("data-imp");
            let ad_id = ads[i].getAttribute("data-id");
            if (ad_imp_url != undefined) {
              vm.ad_imp(ad_id, ad_imp_url);
            }
          }
        }
      }, {
        passive: true
      });
    },
    async is_focused_window() {
      if (document.visibilityState === 'visible') {
        return true;
      }
      document.addEventListener("visibilitychange", function () {
        if (document.visibilityState === 'visible') {
          return true;
        }
      });
    },
    isInViewport(el) {
      const rect = el.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)

      );
    }
  },
  mounted() {
    let vm = this;
    vm.xtoken = $('meta[name="csrf-token"]').attr('content');
    vm.is_focused_window().then(function (result) {
      if (result) {
        vm.scrollListener();
      }
    });

  }
};

</script>
